
export class AppConstants {
    static baseUrl = "/Admin";
    static logoffUrl = "/Admin/AccountCalls/LogOff";
}